import { useEffect } from "react";

import { getTime } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";

import { useTimelineContext } from "../_context";

export const useSetTimestampCursor = (time: Time): void => {
	const { timestampCursor } = useTimelineContext();
	// convert to number for dependency array
	const ms = getTime(time);

	useEffect(() => {
		timestampCursor.setValue(ms);
	}, [timestampCursor, ms]);

	useEffect(
		() => () => {
			timestampCursor.setValue(undefined);
		},
		[timestampCursor],
	);
};
